var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1630502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4246,
    cy: 19.4246,
    r: 19.4246,
    fill: "#3E9FF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8083_35635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6387 27.2773C19.6277 27.2878 19.6169 27.2986 19.6055 27.3086C19.4285 27.4627 19.2015 27.5479 18.9668 27.5479C18.7321 27.5478 18.5051 27.4627 18.3281 27.3086C18.3166 27.2986 18.3059 27.2878 18.2949 27.2773H19.6387Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.998 14.3672V17.1422",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0147 10.666C15.9481 10.666 13.4647 13.1493 13.4647 16.216V17.966C13.4647 18.5327 13.2314 19.3827 12.9397 19.866L11.8814 21.6327C11.2314 22.7243 11.6814 23.941 12.8814 24.341C16.8647 25.666 21.1731 25.666 25.1564 24.341C26.2814 23.966 26.7647 22.6493 26.1564 21.6327L25.0981 19.866C24.8064 19.3827 24.5731 18.5243 24.5731 17.966V16.216C24.5647 13.166 22.0647 10.666 19.0147 10.666Z",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7731 24.6836C21.7731 26.2086 20.5231 27.4586 18.9981 27.4586C18.2397 27.4586 17.5397 27.1419 17.0397 26.6419C16.5397 26.1419 16.2231 25.4419 16.2231 24.6836",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8083_35635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.99805 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1630502);
export default __webpack_public_path__ + "static/media/Frame 163050 (2).b8991fb922da15d74375a2e48104872e.svg";
export { ForwardRef as ReactComponent };